import { render, staticRenderFns } from "./ShowCusPay.vue?vue&type=template&id=38ecdd49"
import script from "./ShowCusPay.vue?vue&type=script&lang=js"
export * from "./ShowCusPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports